import React, { Fragment } from 'react'
import { Typography, Grid } from '@mui/material';
import './errors.scss';

const PageNotFound: React.FC<any> = () => {
  return (
    <Fragment>
      <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '95vh' }}>
        <Grid item xs={12}>
          <div className='error-image'></div>
          <Typography className='error-text' component="h1" variant="h6">
            404: Page not found.
          </Typography>
        </Grid>
      </Grid>
    </Fragment>
  )
}

export default PageNotFound;